// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1iijh","tab":"Tabs_tab__3El-F","tabActive":"Tabs_tabActive__10EOP"};